import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { CONFIG } from 'src/global-config';

import { SvgColor } from 'src/components/svg-color';
import { useLocale } from 'src/locales';

// ----------------------------------------------------------------------

const iconPath = (name) => `${CONFIG.assetsDir}/assets/icons/solid-64/${name}`;

const CORE_VALUES = [
  {
    title: 'Disciplined_Corporate_Methodology',
    description:
      'We_operate_on_a_structured_model_based_on_Service_Level_Agreements_and_long_term_contracts_ensuring_consistent_adherence_to_performance_indicators_and_quality_execution',
    icon: iconPath('ic-report.svg'),
  },
  {
    title: 'Integrated_Digital_Management_Platform',
    description: 'All_operations_are_managed_through_a_unified_digital_ecosystem',
    icon: iconPath('ic-chip.svg'),
  },
  {
    title: 'Transparency_and_Accountability',
    description: 'We_provide_accurate_reports_and_interactive_dashboards',
    icon: iconPath('ic-transparency.svg'),
  },
  {
    title: 'The_Result',
    description:
      'By_combining_technology_with_discipline_we_deliver_sustainable_operational_efficiency',
    icon: iconPath('ic-satisfaction.svg'),
  },
];

// ----------------------------------------------------------------------

export function AboutLeadership({ sx, ...other }) {
  const { t } = useLocale();
  return (
    <Box
      component="section"
      sx={[
        {
          overflow: 'hidden',
          bgcolor: 'background.neutral',
          py: { xs: 5, md: 10 },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <Container>
        <Box
          sx={{
            gap: 3,
            display: 'flex',
            mb: { xs: 5, md: 10 },
            justifyContent: { md: 'space-between' },
            textAlign: { xs: 'center', md: 'left' },
            flexDirection: { xs: 'column', md: 'row' },
          }}
        >
          <Typography variant="h3" sx={{ fontSize: '2rem !important' }}>
            {t('How_We_Achieve_Leadership_in_Performance')}
          </Typography>

          <Typography sx={{ color: 'text.secondary', maxWidth: { md: 540 } }}>
            {t(
              'At_Shahen_operational_excellence_is_not_just_a_goal_it_is_an_integrated_system_that_combines_corporate_discipline_with_intelligent_technology'
            )}
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'grid',
            gap: { xs: 5, md: 8 },
            gridTemplateColumns: {
              xs: 'repeat(1, 1fr)',
              sm: 'repeat(2, 1fr)',
              md: 'repeat(4, 1fr)',
            },
          }}
        >
          {CORE_VALUES.map((item) => (
            <Box key={item.title} sx={{ textAlign: { xs: 'center', md: 'unset' } }}>
              <SvgColor
                src={item.icon}
                sx={(theme) => ({
                  width: 64,
                  height: 64,
                  background: `linear-gradient(to bottom, ${theme.vars.palette.primary.light}, ${theme.vars.palette.primary.main})`,
                })}
              />

              <Typography component="h6" variant="h5" sx={{ mt: 3, mb: 1 }}>
                {t(item.title)}
              </Typography>

              <Typography sx={{ color: 'text.secondary' }}> {t(item.description)} </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
